import { Spinner } from "@heroui/react";
import type { FunctionComponent } from "react";

interface LoadingScreenProps {
    // Define any props if needed
    message?: string;
}

const LoadingScreen: FunctionComponent<LoadingScreenProps> = ({ message }) => {
    return (
        <div className="w-screen h-screen flex items-center justify-center bg-background gap-4">
            <Spinner variant="dots" /> <p className="font-semibold">{message || "Loading"}</p>
        </div>
    );
};

export default LoadingScreen;